import React, { Suspense } from "react";
import axios from "axios";
import {
  defer,
  Await,
  useLoaderData,
  Link,
  useNavigate,
  Form,
} from "react-router-dom";

import {
  ListGroup,
  ListGroupItem,
  Col,
  Button,
  Row,
  Container,
  Card,
} from "react-bootstrap";
/**
 * @author
 * @function TechopsOrganizationTool
 **/

const TechopsOrganizationTool = (props) => {
  const navigate = useNavigate();

  const loaderData = useLoaderData();

  let js = "";

  return (
    <>
      <div>
        <Container>
          <Row>
            <h1>TechOps Tools Search</h1>
            <Col md={8} lg={6} xs={12}>
              Organization Details
              <p>&nbsp;</p>
            </Col>
          </Row>

          <Suspense fallback={<p>Loading...</p>}>
            <ListGroup className="shadow">
              <Await resolve={loaderData.organization}>
                {(organization) => (
                  <div className="p-4">
                    <Row>
                      <Col className="col-2 text-end">Org Id:</Col>
                      <Col>{organization.orgId}</Col>
                    </Row>
                    <Row>
                      <Col className="col-2 text-end">Name:</Col>
                      <Col>{organization.orgName}</Col>
                    </Row>
                    <Row>
                      <Col className="col-2 text-end">Status:</Col>
                      <Col>
                        {organization.isActive == 1 ? "Active" : "Deactivated"}
                      </Col>
                    </Row>

                    <Row className="p-2">
                      <Col className="col-3"></Col>
                      <Col className="col-6">
                        <Form
                          method="post"
                          action={
                            "/techopsTool/organization/" + organization.orgId
                          }
                        >
                          <Button
                            className="btn btn-small"
                            type="submit"
                            disabled={organization.isActive != 1 ? true : false}
                          >
                            Deactivate Organization
                          </Button>
                        </Form>
                      </Col>
                    </Row>
                  </div>
                )}
              </Await>
            </ListGroup>
          </Suspense>
        </Container>
      </div>
    </>
  );
};

export default TechopsOrganizationTool;

export async function loader({ params }) {
  const orgId = params.orgId;

  return defer({ organization: getOrganization(orgId) });
}

async function getOrganization(orgId) {
  let jwtinfo = localStorage.getItem("prod-ftjwt");

  const response = await axios.get("/api/v1/techopsOrganization/" + orgId, {
    headers: {
      "Content-Type": "application/json",
      apikey: "xxyyzz",
      token: jwtinfo,
    },
  });

  return response.data;
}

export async function action({ request, params }) {
  const orgId = params.orgId;
  let jwtinfo = localStorage.getItem("prod-ftjwt");

  const response = await axios.post(
    "/api/v1/disableOrganization/" + orgId,
    {},
    {
      headers: {
        "Content-Type": "application/json",
        apikey: "xxyyzz",
        token: jwtinfo,
      },
    }
  );

  return response.data;
}
